"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.ddSdk = void 0;

var env_1 = require("./env"),
    log_1 = require("./log"),
    env_2 = require("./env");

Object.defineProperty(exports, "ENV_ENUM", {
  enumerable: !0,
  get: function get() {
    return env_2.ENV_ENUM;
  }
}), Object.defineProperty(exports, "ENV_ENUM_SUB", {
  enumerable: !0,
  get: function get() {
    return env_2.ENV_ENUM_SUB;
  }
});

var sdk_1 = require("./sdk");

require("./polyfills"), exports.ddSdk = new sdk_1.Sdk(env_1.getENV(), log_1.log);